module.exports = __webpack_public_path__ + "static/media/Swiss721BT-BoldCondensed.6c412337.woff2";